export const environment = {
    production: true,
    endpoints: {
      activityPostModerateApi:'https://quamoderationservicesvcp18.azurewebsites.net/moderated-post',
      activityPostRemovalApi:'https://quamoderationservicesvcp18.azurewebsites.net/moderated-post/remove-post/',
      activityCommentRemovalApi:'https://quamoderationservicesvcp18.azurewebsites.net/moderated-post/remove-comment/',
      privateContentApi : 'https://quaprivateusercontentservicesvcp18.azurewebsites.net'
    },
    authentication: {
        tenant:'isagenixcorpsso.onmicrosoft.com',
        clientId:'7df7fbeb-4cb9-4e03-8e20-4c0e13831304'
    }
};



// WEBPACK FOOTER //
// C:/Projects/Isagenix/GitHub/Mobile.IsaLifeAzure/apps/qualia-platform-admin-web/src/environments/environment.ts